import { refs, domReady, dispatchEvent, booleanDataset } from '../modules/utils.js';

class ProductCard extends HTMLElement {
  static get observedAttributes() {
    return [];
  }

  attributeChangedCallback(name, oldValue, newValue) { }

  async connectedCallback() {
    await domReady();
    this.refs = refs(this);
    const video = this.querySelector('video');
    if (video) {
      this.refs.video = video;
    }
    this.#listeners();
  }

  #listeners() {
    this.refs.addToCart?.addEventListener('click', (e) => this.#addToCardHandle(e));
    this.refs.addToCartMobile?.addEventListener('click', (e) => this.#addToCardHandle(e));
    if (this.refs.video) {
      this.addEventListener('mouseenter', () => {
        this.refs.video.play();
      });
      this.addEventListener('mouseleave', () => {
        this.refs.video.pause();
      });
    }
  }

  async #addToCardHandle(e) {
    if (this.dataset.firstAvailableVariantId) {
      e.preventDefault();
      e.stopPropagation();

      let formData = {
        'items': [{
          'id': this.dataset.firstAvailableVariantId,
          'quantity': 1
        }]
      };

      this.refs.addToCart && booleanDataset(this.refs.addToCart, 'loading', true);
      this.refs.addToCartMobile && booleanDataset(this.refs.addToCartMobile, 'loading', true);

      return fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
        .then(response => response.json())
        .then(data => {
          dispatchEvent('cart:update', { cart: data });
          dispatchEvent('productcard:added');
          this.refs.addToCart && booleanDataset(this.refs.addToCart, 'loading', false);
          this.refs.addToCartMobile && booleanDataset(this.refs.addToCartMobile, 'loading', false);
        })
        .catch((error) => {
          console.error('Error:', error);
          this.refs.addToCart && booleanDataset(this.refs.addToCart, 'loading', false);
          this.refs.addToCartMobile && booleanDataset(this.refs.addToCartMobile, 'loading', false);
        });
    }
  }
}

customElements.define('product-card', ProductCard);
